// extracted by mini-css-extract-plugin
export default {"arrowLinkIcon":"MobileHomeIcons_arrowLinkIcon__NEj19","chevronGoIcon":"MobileHomeIcons_chevronGoIcon__eHxT4"};